import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

import { createStore } from './src/shared/redux/store';
import theme from './src/shared/theme';

import { WrapRootElementBrowserArgs, WrapRootElementNodeArgs } from 'gatsby';

export default ({ element }: (WrapRootElementBrowserArgs | Omit<WrapRootElementNodeArgs, 'pathname'>)) => {
  const store = createStore()

  return (
    <ReduxProvider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        {element}
      </ThemeProvider>
    </ReduxProvider>
  )
}
